import React, { Component } from 'react'
import PageHeaderWrapper from '../../../components/PageHeaderWrapper'
import { Button, Card, Form, notification, Popconfirm, Tabs, Tooltip } from 'antd'
import { TableComp, FormUtils as GetAllFormFields } from 'sz-react-utils'
import Request from '../../../request'
import styles from '../../Template/all/styles.less'
import moment from 'moment'
import _ from 'lodash'

import { RightsWrapper } from '../../../components/_utils/utils'
const TabPane = Tabs.TabPane

@Form.create()

class AllVendors extends Component {
  state = {
    vendorId: '',
    total: 0,
    activeTab: '0',
    refreshChild: false,
    countryArr: [],
    phoneCodes: [],
  }

  apiRequest = params => {
    return new Promise(async resolve => {
      this.setState({ exportParams: params })
      let data = await Request.getVendorsDetails({
        ...params,
        regExFilters: []
      })
      this.setState({ total: data.total })
      resolve(data)
    })
  }
  handleSubmit = e => {
    const { dispatch, form } = this.props
    e.preventDefault()
    form.validateFieldsAndScroll(async (err, valData) => {
      if (!err) {
        let values = _.clone(valData)
        let x = null
        if (this.state.vendorId) {
          values._id = this.state.vendorId
          x = await Request.updateVendorsDetails(values)
        } else {
          x = await Request.addVendorsDetails(values)
        }

        if (!x.error) {
          this.setState({
            id: '',
            activeTab: '0',
          })
          notification.success({
            message: this.state.id
              ? `Vendor Updated Successfully`
              : 'Vendor Added successfully'
          })
          if (!this.state.id) {
            form.resetFields()
          }
          if (this.table && this.table.current)
            this.table.current.reload()

        } else {
          notification.error({
            message: 'Error Saving',
            description: x.msg
          })
        }
      }
    })
  }
  deleteVendorsDetails = async data => {
    this.setState({ loading: true })
    await Request.deleteVendorsDetails(data)

    this.setState({ loading: false })

    this.table.current.reload()

    notification.success({
      message: 'Deleted Successfully',
      duration: 20,
      key: `${data._id}-close`
    })
  }
  callback = (value) => {
    if (value) {
      this.chooseTab(value)
    }
  }
  setVendorsData(vendorId) {
    if (vendorId) {
      Request.getVendorsByID({ id: vendorId }).then(
        ({ doc, error, message }) => {
          if (!error && doc) {
            this.setState({
              vendorId: doc._id,
              activeTab: '1'
            })

            this.props.form.setFieldsValue({
              vendorName: doc.vendorName,
              vendorAddress: doc.vendorAddress,
              vendorEmail: doc.vendorEmail,
              vendorPhone: doc.vendorPhone,
              vendorCountryId: doc.vendorCountryId,
              vendorStatus: doc.vendorStatus
            })
          } else {
            notification.error({
              message: 'Error Getting Data',
              description: message
            })
          }
        }
      )
    }
  }
  refreshFxn = () => {
    this.setState({ refreshChild: !this.state.refreshChild })
  }

  loadCountries = () => {
    let params = {
      results: 200,
      sortField: "countryName",
      sortOrder: "ascend",
    };
    Request.getCountriesWithoutAuth({ ...params })
      .then((resp) => {
        let countryArr = [];
        let phoneCodes = [];
        resp.data = resp.data.reduce((temp, vv) => {
          countryArr.push({ _id: vv._id, display: vv.countryName });
          phoneCodes.push({ _id: vv.countryPhoneCode, display: vv.countryPhoneCode });
        }, []);
        this.setState({ countryArr: countryArr, phoneCodes });
      })
      .catch((err) => {
        console.log(err);
      });
  };

  componentWillMount() {

  }

  async componentDidMount() {
    this.loadCountries();
  }

  constructor(props) {
    super(props)
    this.table = React.createRef()
  }
  chooseTab(value) {
    this.setState({
      activeTab: value
    })
  }
  render() {
    const { dispatch } = this.props
    const {
      form: { getFieldDecorator, setFieldsValue }
    } = this.props
    const { vendorId, countryArr, phoneCodes } = this.state;

    const inputTypes = {
      fields: [
        {
          label: 'Vendor Name',
          key: 'vendorName',
          required: true
        },
        {
          label: 'Vendor Address',
          type: 'textarea',
          key: 'vendorAddress',
          required: true
        },
        {
          label: 'Vendor Email',
          type: 'email',
          key: 'vendorEmail',
          required: true
        },
        {
          label: 'Vendor Phone Code',
          key: 'vendorPhoneCode',
          required: true,
          type: 'select',
          options: phoneCodes,
          onChange: v => {
            this.props.form.setFieldsValue({
              vendorPhoneCode: v
            })
          }
        },
        {
          label: 'Vendor Phone',
          key: 'vendorPhone',
          required: true
        },
        {
          label: 'Vendor Country',
          key: 'vendorCountryId',
          required: true,
          type: "select",
          showSearch: true,
          options: countryArr,
          onChange: (v) => {
            this.props.form.setFieldsValue({
              vendorCountryId: v
            });
          },
        },
        {
          label: 'Status',
          key: 'vendorStatus',
          type: 'select',
          required: true,
          showSearch: true,
          disabled: false,
          options: [
            'Active', 'Inactive'
          ],
          onChange: v => {
            this.props.form.setFieldsValue({
              vendorStatus: v
            })
          }
        }
      ]
    };

    const columns = [
      {
        title: 'Vendor Name',
        key: 'vendorName',
        searchTextName: 'Vendor Name',
      },
      {
        title: 'Vendor Phone',
        key: 'vendorPhone',
        searchTextName: 'Vendor Phone'
      },
      {
        title: 'Vendor Country',
        key: 'vendorCountryId',
        dataIndex: 'vendorCountryId.countryName',
        filters:
          countryArr &&
          countryArr.map((x) => ({ value: x._id, text: x.display })),
      },
      {
        title: 'Created By',
        key: 'lastUpdatedByName',
        dataIndex: 'lastUpdatedByName',
        searchTextName: 'Created By / Updated By',
        render: (text, record) => {
          return (
            <div>
              <div>{record.updatedByUser != null ? record.updatedByUser.name : record.createdByUser != null ? record.createdByUser.name : ""}</div>
              <small>{record.updatedByUser ? moment(record.updatedByUser.time).format('lll') : record.createdByUser ? moment(record.createdByUser.time).format('lll') : ''}</small>
            </div>
          )
        }
      },
      {
        title: 'Action',
        key: 'operation',
        render: (text, record) => (
          <React.Fragment>
            <RightsWrapper myRight={'vendors.edit'}>
              <Tooltip title="Edit Vendor">
                <Button
                  className={styles.btn}
                  shape="circle"
                  onClick={() => {
                    this.setVendorsData(record._id)
                  }}
                  icon="edit"
                />
              </Tooltip>
            </RightsWrapper>
            <RightsWrapper myRight={'vendors.delete'}>
              <Tooltip title="Delete Vendor">
                <Popconfirm
                  title="Are you sure delete this Vendor?"
                  onConfirm={() => {
                    this.deleteVendorsDetails({ _id: record._id })
                  }}
                  okText="Yes"
                  cancelText="No">
                  <Button
                    className={styles.btn}
                    shape="circle"
                    icon="delete"
                  />
                </Popconfirm>
              </Tooltip>
            </RightsWrapper>
          </React.Fragment>
        )
      }
    ]
    return (
      <PageHeaderWrapper title={` Vendors  `}>
        <Card bordered={true}>
          <Tabs onChange={this.callback} type="card" activeKey={this.state.activeTab}>
            <TabPane tab={`All Vendors`} key={0}>
              <h2>{`Total : ${this.state.total}`}</h2>
              <TableComp
                ref={this.table}
                columns={columns}
                apiRequest={this.apiRequest}
                extraProps={{ scroll: { x: 900 } }}
                pagination={{
                  showSizeChanger: true,
                  defaultPageSize: 50,
                  pageSizeOptions: ['10', '20', '50', '100', '1000']
                }}
              />
            </TabPane>

            <TabPane tab={(vendorId ? 'Edit' : 'Add') + ' Vendor'} key={1}>
              <Form onSubmit={this.handleSubmit} style={{ marginTop: 8 }}>
                <GetAllFormFields
                  inputSchema={inputTypes}
                  refresh={this.refreshFxn}
                  getFieldDecorator={getFieldDecorator}
                />
                <Button
                  type=""
                  htmlType="submit"
                  style={{
                    marginBottom: 10,
                    marginLeft: '33%',
                    backgroundColor: 'green',
                    color: 'white'
                  }}
                  loading={this.props.loading}>
                  SAVE
                </Button>
                <Button
                  type="primary"
                  style={{ marginBottom: 10, marginLeft: '1%' }}
                  loading={this.props.loading}
                  onClick={() => {
                    this.props.form.resetFields()
                  }}>
                  RESET
                </Button>
              </Form>
            </TabPane>
          </Tabs>
        </Card>
      </PageHeaderWrapper>
    );
  }
}

export default AllVendors
